/**
 * Resolve the HTTP port Runeya should listen on.
 *
 * Priority: RUNEYA_HTTP_PORT > PORT > 4000 (default)
 *
 * Throws if the resolved value is not an integer in [1, 65535].
 */
export function resolvePort(): number {
  const raw = process.env.RUNEYA_HTTP_PORT ?? process.env.PORT;
  if (raw === undefined) return 4000;

  const port = Number(raw);
  if (!Number.isInteger(port) || port < 1 || port > 65535) {
    throw new Error(
      `Invalid port: ${JSON.stringify(raw)}. Must be an integer between 1 and 65535.`,
    );
  }
  return port;
}
